import * as React from "react";

var DetailTable = function DetailTable(props) {
  var polizaRenewal = props.polizaRenewal;
  return /*#__PURE__*/React.createElement("tbody", {
    className: "table-bordered"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Detalles de condiciones:"), /*#__PURE__*/React.createElement("td", null, polizaRenewal.condition_details), /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Requiere inspecci\xF3n:"), /*#__PURE__*/React.createElement("td", null, polizaRenewal.inspection_needed ? "Sí" : "No")));
};

export default DetailTable;